var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.context.classes.element,
      attrs: {
        "data-is-repeatable": _vm.context.repeatable,
        role: "group",
        "aria-labelledby": _vm.labelledBy
      }
    },
    [
      _c(
        "FormulateSlot",
        { attrs: { name: "prefix", context: _vm.context } },
        [
          _vm.context.slotComponents.prefix
            ? _c(_vm.context.slotComponents.prefix, {
                tag: "component",
                attrs: { context: _vm.context }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.subType !== "grouping"
        ? _vm._l(_vm.optionsWithContext, function(optionContext) {
            return _c(
              "FormulateInput",
              _vm._b(
                {
                  key: optionContext.id,
                  staticClass: "formulate-input-group-item",
                  attrs: { "disable-errors": true, "prevent-deregister": true },
                  on: { blur: _vm.context.blurHandler },
                  model: {
                    value: _vm.context.model,
                    callback: function($$v) {
                      _vm.$set(_vm.context, "model", $$v)
                    },
                    expression: "context.model"
                  }
                },
                "FormulateInput",
                optionContext,
                false
              )
            )
          })
        : [
            _c(
              "FormulateGrouping",
              { attrs: { context: _vm.context } },
              [_vm._t("default")],
              2
            ),
            _vm._v(" "),
            _vm.canAddMore
              ? _c(
                  "FormulateSlot",
                  {
                    attrs: {
                      name: "addmore",
                      context: _vm.context,
                      "add-more": _vm.addItem
                    }
                  },
                  [
                    _c(
                      _vm.context.slotComponents.addMore,
                      _vm._b(
                        {
                          tag: "component",
                          attrs: {
                            context: _vm.context,
                            "add-more": _vm.addItem
                          },
                          on: { add: _vm.addItem }
                        },
                        "component",
                        _vm.context.slotProps.addMore,
                        false
                      )
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
      _vm._v(" "),
      _c(
        "FormulateSlot",
        { attrs: { name: "suffix", context: _vm.context } },
        [
          _vm.context.slotComponents.suffix
            ? _c(_vm.context.slotComponents.suffix, {
                tag: "component",
                attrs: { context: _vm.context }
              })
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }